import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './RelatedAddressesSection.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import lang from 'dojo/_base/lang';
import RelatedAddressEditor from './RelatedAddressEditor/RelatedAddressEditor';
import { Address, RelatedAddress } from "./RelatedAddressTypes";
import { ExpandableSection, ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";

class RelatedAddressesSection extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private address: Address;

    private relatedAddressTable: MdsLax<InstanceType<typeof StaticTable>>;
    private relatedAddressStore: MdsLax<InstanceType<typeof EntityStore<RelatedAddress>>>;

    private realtedAddressExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    private tableContainer: HTMLDivElement;

    private rowConfig: StaticTable.RowConfig = {
        attributes: [
            "ref_address.gDisp_1",
            "c_relation_type",
            "ref_related_address.gDisp_1",
            "is_active"
        ],
        headings: [
            (this as any).translate("General_Label_ThisAddress"),
            (this as any).translate("General_Label_RelationType"),
            (this as any).translate("General_Label_RelatedToAddress"),
            (this as any).translate("General_Label_IsActive")
        ],
        colNamesInternal: [
            "ref_address.gDisp_1",
            "c_relation_type",
            "ref_related_address.gDisp_1",
            "is_active"
        ]
    }

    private tableLayout: StaticTable.Layout = {
        label: "relatedAddresTable",
        name: "relatedAddressTable",
        rows: [(this as any).rowConfig]
    }

    setup(address: Address): void {
        this.address = address;

        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API_AddressWizard__RelatedAddresses_GetRelatedAddresses", { address: this.address }, lang.hitch(this, this._onGetRelatedAddressesResponse), lang.hitch(this, this._onGetRelatedAddressesError));

    }

    private _onGetRelatedAddressesResponse(response: Array<any>) {
        this.StandbyStop();
        this.relatedAddressStore.setup(response);
        this.realtedAddressExpander.setMarking(response.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }

    private _onGetRelatedAddressesError(error) {
        this.StandbyStop();
        console.error(error);
    }

    private _onClickEditButton(rowGroup: StaticTable.StaticTableRowGroup<RelatedAddress>): void {
        var entity = rowGroup.entity;
        this._openRelatedAddressEditor(entity);
    }

    private _onClickTableRow(row: StaticTable.StaticTableRow<RelatedAddress>): void {
        var entity = row.rowGroup.entity;
        this._openRelatedAddressEditor(entity);
    }

    private _onClickNewButton(e): void {
        this._openRelatedAddressEditor();
    }

    private _onClickReloadButton(e): void {
        this.setup(this.address);
        this.emit("reloaded");
    }

    private _openRelatedAddressEditor(relatedAddress?: any) {
        let editor = new RelatedAddressEditor();
        editor.on("confirmed", lang.hitch(this, this._onEditorConfirmed));
        let entity;
        let isNew;

        if (relatedAddress) {
            entity = relatedAddress;
            isNew = false;
        } else {
            entity = {
                ref_address: this.address
            }
            isNew = true;
        }
        editor.openEditor(entity, isNew);
    }

    private _onEditorConfirmed(data: any) {
        if (data.isNew) {
            this.relatedAddressStore.addEntry(data.entity);
        } else {
            this.relatedAddressStore.changeEntry(data.entity, true);
        }
    }

    private setupTable(): void {
        this.relatedAddressTable = new StaticTable();
        this.relatedAddressTable.setLayout(this.tableLayout);
        this.relatedAddressTable.addDefaultRowActionButton("delete");
        this.relatedAddressTable.addDefaultRowActionButton("edit", lang.hitch(this, this._onClickEditButton));
        this.relatedAddressTable.setRowClick(lang.hitch(this, this._onClickTableRow));
        this.relatedAddressTable.setupFromStore(this.relatedAddressStore);

        this.relatedAddressTable.placeAt(this.tableContainer);

        this.relatedAddressTable.setCyAttribute("relatedAddresses");
    }

    private _onStoreChange(): void {
        this.realtedAddressExpander.setMarking(this.relatedAddressStore.getCurrentCompleteList().length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        var diffData = this.relatedAddressStore.getDiffData();
        this.emit("change", diffData);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);


        this.relatedAddressStore = new EntityStore();
        this.relatedAddressStore.on("change", lang.hitch(this, this._onStoreChange));
        this.setupTable();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(RelatedAddressesSection);